import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router';
import piwikMethod from '../../../utils/analytics/piwikMethod';
/**
 * Non-themeable component which logs a piwik event whenever the current url changes.
 *
 * By default, it logs `setDocumentTitle`, `setCustomUrl` and `trackPageView`
 *
 * To track any other piwik events, google analytics or alternative analytics library, an array of functions must be passed in for `onPageChange`
 *
 * Supports the same props as a React Router [Route](https://reacttraining.com/react-router/web/api/Route) component
 *
 * ```js
 * import { EventRoute } from '@minerva-analytics/pantheon';
 *
 * <Switch>
 *   {routes.map((r) => (
 *       <EventRoute {...r} />
 *    ))}
 * </Switch>
 * ```
 */

var EventRoute = function EventRoute(props) {
  useEffect(function () {
    piwikMethod("setDocumentTitle", [document.title]);
    piwikMethod("setCustomUrl", [props.location.pathname + props.location.search]);
    piwikMethod("trackPageView", []);

    if (props.onPageChange) {
      props.onPageChange.map(function (func) {
        return func();
      });
    }
  }, [props.location]);
  return /*#__PURE__*/React.createElement(Route, props);
};

EventRoute.propTypes = {
  /** Optional array of additional functions to track upon page change */
  onPageChange: PropTypes.array
};
export default EventRoute;